















import { Component, Vue } from 'vue-property-decorator'

@Component
export default class WelcomeBlock extends Vue {
    drinking: boolean = false

    mounted(): void {
        this.animateDrinking(0)
    }

    async animateDrinking(maxTimeout: number, minTimeout: number = 5): Promise<void> {
        const timeout = minTimeout + Math.floor(Math.random() * (maxTimeout - minTimeout))

        await this.wait(timeout * 1000)
        this.drinking = true
        await this.wait(2 * 1000)
        this.drinking = false

        this.animateDrinking(15)
    }

    async wait(milliseconds: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }
}
